import { Button, Result } from "antd";
import { useNavigate, useRouteError } from "react-router-dom";

const ErrorBoundary = () => {
  const error = useRouteError(); // This will give you the error object if there's one
  const navigate = useNavigate();

  const navigateToHome = () => {
    navigate("/");
  };
  console.error("Captured error:", error);

  // You can check the error and display more specific messages if needed
  return (
    <Result
      subTitle={
        <>
          <h1>CAUTION !</h1>
          <p>Sorry, we encountered an issue while loading.</p>
          <p>Please, refresh this page.</p>
        </>
      }
      extra={
        <Button type="primary" onClick={navigateToHome}>
          Back to Home
        </Button>
      }
    />
  );
};

export default ErrorBoundary;
